import {NgModule} from '@angular/core';
import {CarouselComponent} from './carousel.component';
import {CommonModule} from '@angular/common';
import {CarouselItemDirective} from './carousel-item.directive';
import {CAROUSEL_PROVIDERS} from './carousel.providers';

@NgModule({
  declarations: [CarouselComponent, CarouselItemDirective],
  exports: [CarouselComponent, CarouselItemDirective],
  imports: [CommonModule],
  providers: [CAROUSEL_PROVIDERS],
})
export class CarouselModule {}
